import React from "react";

import {IconButton, useTheme} from '@material-ui/core';
import Forward30Icon from '@material-ui/icons/Forward30';

const Forward = (props) => {
    const theme = useTheme();
    return(
        <IconButton aria-label="Backward" style={{color: theme.palette.iconColor}}>
            <Forward30Icon fontSize="large" />
        </IconButton>
    );
};

export default Forward;